import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import dealsOperations from "../deals/ducks/operations";
import documentActions from "../documents/ducks/actions";
import documentOperations from "../documents/ducks/operations";
import utils from "../utils/index";
import voucherOperations from "../voucher/ducks/operations";
import constants from "./constants";
import DealSummary from "./DealSummary";
import operations from "./ducks/operations";

const DealContainer = (props) => {
    const { handleGetDealSummary } = props;

    const { id } = useParams();

    useEffect(() => {
        handleGetDealSummary(id);
        ReactGA.send({ hitType: "pageview", page: "/deal/*", title: `Deal Summary: ${id}` });
    }, []);

    return <DealSummary {...props} dealId={id} />;
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.authReducer.userProfile,
        values: state.dealReducer.dealSummary,
        loading: state.utilsReducer.loading,
        isLoading: state.utilsReducer.isLoading,
        isLoadingContent: state.utilsReducer.isLoadingContent,
        columnToSort: state.dealReducer.dealSummary.columnToSort,
        sortDirection: state.dealReducer.dealSummary.sortDirection,
        creator: state.dealReducer.creator,
        savedDocuments: state.documentsReducer.savedDocuments,
        missingRequiredDocuments: state.documentsReducer.missingRequiredDocuments,
        role: state.authReducer.userProfile.role,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleGetDealSummary: (dealId) => {
            dispatch(operations.getDealSummary(dealId));
        },
        handleSort: (columnName) => {
            dispatch(operations.handleSort(columnName));
        },
        addVoucherInstallment: (voucherKey, dealKey) => {
            return dispatch(operations.addVoucherInstallment(voucherKey, dealKey));
        },
        setLoader: (name, isLoading) => {
            dispatch(utils.operations.setLoader(name, isLoading));
        },
        startVoucher: (dealKey) => {
            return dispatch(voucherOperations.startVoucher(dealKey));
        },
        startDeal: (dealKey) => {
            return dispatch(operations.startDeal(dealKey));
        },
        handleStartReviewingAsCorporateData: (deal, currentPath) => {
            return dispatch(dealsOperations.handleStartReviewingAsCorporateData(deal, currentPath));
        },
        deleteDeal: (dealKey) => {
            return dispatch(operations.deleteDeal(dealKey));
        },
        loadDealDocumentList: (dealKey) => {
            dispatch(documentOperations.getDocuments(constants.urls.get_deal_document_list(dealKey)));
        },
        handleDownloadDealDocuments: (dealKey) => {
            dispatch(operations.downloadDealDocuments(dealKey));
        },
        clearSavedDocuments: (savedDocuments, usedDocTypes) => {
            dispatch(documentActions.receiveDocuments(savedDocuments, usedDocTypes));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DealContainer);
